export const ls = {
    name: "ls",
    description: "Lists files in current directory",
    run: (_: string[], context: any) =>
        context.currentDir.children.map(f => f.name).join("  ")
};